import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import {
  Box,
  Typography,
  Paper,
  TextField,
  InputLabel,
  FormControl,
  Grid,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import PrimaryButton from 'ui-component/button/PrimaryButton';
import toast from 'react-hot-toast';
import { changePassword } from 'store/slices/Auth';

// ---------- Styled Components ----------
const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(2),
}));

const Card = styled(Paper)(({ theme }) => ({
  maxWidth: 420,
  width: '100%',
  padding: theme.spacing(4),
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: theme.shadows[3],
}));

const FormGrid = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

// ---------- Component ----------
const ChangePassword = () => {
  const dispatch = useDispatch();
  const [form, setForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!form.currentPassword || !form.newPassword || !form.confirmPassword) {
      toast.error('All fields are required');
      return;
    }

    if (form.newPassword !== form.confirmPassword) {
      toast.error('New password and confirm password do not match');
      return;
    }

    try {
      const payload = {
        old_password: form.currentPassword,
        new_password: form.newPassword,
      };

    const res=await dispatch(changePassword(payload));
      toast.success(res?.message ||'Password updated successfully!');
      setForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
    } catch (err) {
      toast.error(err || 'Failed to update password');
    }
  };

  return (
    <Wrapper>
      <Card>
        <Typography variant="h5" textAlign="center" fontWeight={700}>
          Change Password
        </Typography>

        <FormGrid container spacing={2}>
          <Grid item xs={12}>
            <InputLabel>Current Password</InputLabel>
            <FormControl fullWidth>
              <TextField
                variant="filled"
                placeholder="Enter current password"
                type="password"
                name="currentPassword"
                value={form.currentPassword}
                onChange={handleChange}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <InputLabel>New Password</InputLabel>
            <FormControl fullWidth>
              <TextField
                variant="filled"
                placeholder="Enter new password"
                type="password"
                name="newPassword"
                value={form.newPassword}
                onChange={handleChange}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <InputLabel>Confirm New Password</InputLabel>
            <FormControl fullWidth>
              <TextField
                variant="filled"
                placeholder="Re-enter new password"
                type="password"
                name="confirmPassword"
                value={form.confirmPassword}
                onChange={handleChange}
              />
            </FormControl>
          </Grid>
        </FormGrid>

        <PrimaryButton
          title="Update Password"
          fullWidth
          onClick={handleSubmit}
        />
      </Card>
    </Wrapper>
  );
};

export default ChangePassword;
